const styleSheet = () => ({
  modalBackdropContainer: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: "fixed",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.85)",
  },
  container: {
    position: "absolute",
    width: "90%",
    height: "90%",
    top: "5%",
    left: "5%",
  },
  close: {
    position: "absolute",
    right: 0,
    top: 0,
    width: "40px",
    height: "40px",
    zIndex: 10000,
    border: 0,
    background: "transparent",
    cursor: "pointer",
    marginTop: "15px",
    marginRight: "20px",
    outline: 0,
  },
});

export default styleSheet;
